/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAnswer } from './PaxCheckAnswer';
import {
    PaxCheckAnswerFromJSON,
    PaxCheckAnswerFromJSONTyped,
    PaxCheckAnswerToJSON,
    PaxCheckAnswerToJSONTyped,
} from './PaxCheckAnswer';

/**
 * Request to set nationality, birthdate, answers to questions and confirm/refute declarations
 * @export
 * @interface PaxCheckSetAnswersRequest
 */
export interface PaxCheckSetAnswersRequest {
    /**
     * Nationality, nullable
     * @type {string}
     * @memberof PaxCheckSetAnswersRequest
     */
    nationality?: string | null;
    /**
     * Birthdate, nullable
     * @type {Date}
     * @memberof PaxCheckSetAnswersRequest
     */
    birthdate?: Date | null;
    /**
     * List of answers, nullable
     * @type {Array<PaxCheckAnswer>}
     * @memberof PaxCheckSetAnswersRequest
     */
    answers?: Array<PaxCheckAnswer> | null;
    /**
     * List of declaration ids to confirm
     * @type {Array<string>}
     * @memberof PaxCheckSetAnswersRequest
     */
    confirmDeclarations?: Array<string> | null;
    /**
     * List of declaration ids to refute
     * @type {Array<string>}
     * @memberof PaxCheckSetAnswersRequest
     */
    refuteDeclarations?: Array<string> | null;
}

/**
 * Check if a given object implements the PaxCheckSetAnswersRequest interface.
 */
export function instanceOfPaxCheckSetAnswersRequest(value: object): value is PaxCheckSetAnswersRequest {
    return true;
}

export function PaxCheckSetAnswersRequestFromJSON(json: any): PaxCheckSetAnswersRequest {
    return PaxCheckSetAnswersRequestFromJSONTyped(json, false);
}

export function PaxCheckSetAnswersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckSetAnswersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'nationality': json['nationality'] == null ? undefined : json['nationality'],
        'birthdate': json['birthdate'] == null ? undefined : (new Date(json['birthdate'])),
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(PaxCheckAnswerFromJSON)),
        'confirmDeclarations': json['confirm_declarations'] == null ? undefined : json['confirm_declarations'],
        'refuteDeclarations': json['refute_declarations'] == null ? undefined : json['refute_declarations'],
    };
}

export function PaxCheckSetAnswersRequestToJSON(json: any): PaxCheckSetAnswersRequest {
    return PaxCheckSetAnswersRequestToJSONTyped(json, false);
}

export function PaxCheckSetAnswersRequestToJSONTyped(value?: PaxCheckSetAnswersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nationality': value['nationality'],
        'birthdate': value['birthdate'] == null ? undefined : ((value['birthdate'] as any).toISOString().substring(0,10)),
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(PaxCheckAnswerToJSON)),
        'confirm_declarations': value['confirmDeclarations'],
        'refute_declarations': value['refuteDeclarations'],
    };
}

